// extracted by mini-css-extract-plugin
module.exports = {"root":"Phone_root__1tlv-"};